import { EmptyComponent } from "../common/EmptyComponent.js";
import Loadable from "react-loadable";

export const LanguagesMenu = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "menu/language" */
      "./LanguagesMenu.js"
    ),
  loading: EmptyComponent
});

export const LanguagesMenuPC = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "menu/pc/languages" */
      "./LanguagesMenu.pc.js"
    ),
  loading: EmptyComponent
});

export const LanguagesMenuMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "menu/mobile/languages" */
      "./LanguagesMenu.mobile.js"
    ),
  loading: EmptyComponent
});
